import { Box, Checkbox, Typography } from '@material-ui/core';
import React from 'react';
import { ApprovalConfigurationUsageEntry } from '../../panels/ApprovalConfigurations/types';
import useStyles from './dialog.styles';

interface UsageEntryProps {
  entry: ApprovalConfigurationUsageEntry
  checked: boolean
  onChange: (id: string) => void
}

const UsageEntry: React.FunctionComponent<UsageEntryProps> = ({
  entry,
  checked,
  onChange,
}) => {
  const classes = useStyles();
  return (
    <Box className={classes.usageEntry}>
      <Checkbox
        checked={checked}
        onChange={() => onChange(entry.id)}
        color="primary"
      />

      <Box>
        <Typography variant="body1">
          {entry.docId}
        </Typography>

        {entry.description && (
          <Box
            dangerouslySetInnerHTML={{
              __html: entry.description,
            }}
          />
        )}
      </Box>
    </Box>
  );
};

export default UsageEntry;
